import React from "react";
import { Flex, GridItem, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Checkbox, Select } from "components";
import { FormValues } from "../../duck";
import { PERIODONTICS_OPTIONS } from "./duck";

const Periodontics: React.FC = () => {
  const { watch, setValue } = useFormContext<FormValues>();
  const periodonticsValues = watch("periodontics");

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    opt: typeof PERIODONTICS_OPTIONS[number]
  ) => {
    const { checked } = event.target;
    if (checked) {
      setValue("periodontics", [...periodonticsValues, opt.value]);
    } else {
      setValue(
        "periodontics",
        periodonticsValues.filter(value => value !== opt.value)
      );
      if (opt.selectOptions) {
        setValue("planingAndSubgingivalCurettage", null);
      }
    }
  };

  return (
    <GridItem>
      <Flex direction="column" rowGap="4">
        <Text fontWeight="semibold" color="gray.600">
          Periodontics
        </Text>

        {PERIODONTICS_OPTIONS.map(opt =>
          opt.selectOptions ? (
            <Flex direction="column" rowGap={1} key={opt.value}>
              <Checkbox
                label={opt.label}
                isChecked={periodonticsValues.includes(opt.value)}
                onChange={event => handleChange(event, opt)}
              />
              <Select
                inputLayoutProps={{ pl: 8 }}
                name="planingAndSubgingivalCurettage"
                isDisabled={!periodonticsValues.includes(opt.value)}
                options={opt.selectOptions}
                placeholder="Select"
              />
            </Flex>
          ) : (
            <Checkbox
              key={opt.value}
              label={opt.label}
              isChecked={periodonticsValues.includes(opt.value)}
              onChange={event => handleChange(event, opt)}
            />
          )
        )}
      </Flex>
    </GridItem>
  );
};

export default Periodontics;
